import { gql } from '@apollo/client';

export const FETCH_VEHICLES = gql`
  query FetchVehicles {
    vehicles {
      id
      plate
      model
      color
      insurance
      policyNumber
      ownership
      usage
      isTrailer
      parentVehicleIDs
      childVehicleIDs
      childVehicle {
        id
        plate
        insurance
        policyNumber
        isTrailer
      }
      isActive
      category
      vehicleCategoryIDs
      concessionIDs
      teamIDs
    }
  }
`;

export const GET_VEHICLE_BY_ID = gql`
  query GetVehicleById($id: ID!, $isTrailer: Boolean) {
    vehicle(id: $id, isTrailer: $isTrailer) {
      id
      plate
      model
      color
      category
      insurance
      policyNumber
      isTrailer
      accidentIDs
      # 🎯 ELIMINADO: vehicleOccupantIDs - Los ocupantes ahora están en VehicleAccidentContext
      parentVehicleIDs
      childVehicle {
        id
        plate
        insurance
        policyNumber
        isTrailer
      }
      vehicleCategoryIDs
      isActive
      concessionIDs
      ownership # ✅ NUEVO
      usage # ✅ NUEVO
      teamIDs
    }
  }
`;

export const GET_VEHICLE_BY_PLATE = gql`
  query GetVehicleByPlate($plate: String!) {
    vehicleByPlate(plate: $plate) {
      id
      plate
      model
      color
      category
      insurance
      policyNumber
      isTrailer
      accidentIDs
      # 🎯 ELIMINADO: vehicleOccupantIDs - Los ocupantes ahora están en VehicleAccidentContext
      parentVehicleIDs
      childVehicle {
        id
        plate
        insurance
        policyNumber
        isTrailer
      }
      vehicleCategoryIDs
      isActive
      concessionIDs
      ownership # ✅ NUEVO
      usage # ✅ NUEVO
      teamIDs
    }
  }
`;

export const GET_VEHICLE_OCCUPANT_BY_ID = gql`
  query GetVehicleOccupantById($id: ID!) {
    vehicleOccupant(id: $id) {
      id
      numberOccupants
      userDriverIDs
      actionIDs
      # 🎯 ELIMINADO: accidentIDs - Los ocupantes de accidentes ahora están en VehicleAccidentContext
      vehicleIDs
    }
  }
`;

// Warm-up de caché para el detalle de OT/campaña y el resumen de actuación:
// resuelve N VehicleOccupant en UNA query servidor (backend
// `vehicleOccupantsByIds`, tenant-scoped, máx 200 ids, orden de salida NO
// garantizado — irrelevante: solo interesa poblar la caché normalizada).
// Selection-set = EXACTAMENTE el de GET_VEHICLE_OCCUPANT_BY_ID (= type
// VehicleOccupant completo; el select backend proyecta esos 5 campos,
// tripwire bidireccional en rois-back
// test/unit/vehicles/vehicle-occupants-by-ids.unit.spec.ts) para que los
// `client.query(GET_VEHICLE_OCCUPANT_BY_ID, cache-first)` per-row den hit
// vía el redirect `Query.vehicleOccupant → toReference` de policies.ts.
export const VEHICLE_OCCUPANTS_BY_IDS_WARMUP = gql`
  query VehicleOccupantsByIds($ids: [ID!]!) {
    vehicleOccupantsByIds(ids: $ids) {
      id
      numberOccupants
      userDriverIDs
      actionIDs
      vehicleIDs
    }
  }
`;

export const FILTER_VEHICLES = gql`
  query FilterVehicles($input: FilterVehicle!) {
    filterVehicles(input: $input) {
      id
      plate
      model
      color
      insurance
      policyNumber
      ownership
      usage
      isTrailer
      parentVehicleIDs
      childVehicleIDs
      childVehicle {
        id
        plate
        insurance
        policyNumber
        isTrailer
      }
      isActive
      category
      vehicleCategoryIDs
      concessionIDs
      teamIDs
    }
  }
`;

export const GET_VEHICLES = gql`
  query GetVehicles {
    readVehicles @client {
      id
      plate
      model
      color
      insurance
      policyNumber
      isTrailer
      parentVehicleIDs
      childVehicleIDs
      isActive
      category
      vehicleCategoryIDs
      concessionIDs
      ownership
      usage
      teamIDs
    }
  }
`;

export const GET_ACTIVE_VEHICLES = gql`
  query GetVehiclesInternals {
    readActiveVehicles @client {
      id
      plate
      model
      color
      insurance
      policyNumber
      isTrailer
      parentVehicleIDs
      childVehicleIDs
      isActive
      concessionIDs
      ownership
      usage
      category
      teamIDs
    }
  }
`;

export const GET_VEHICLE_OCCUPANT_BY_VEHICLE_ID = gql`
  query GetVehicleOccupantsByVehicleId($vehicleId: ID!) {
    vehicleOccupantByVehicleId(vehicleId: $vehicleId) {
      id
      numberOccupants
      userDriverIDs
      actionIDs
      accidentIDs
      vehicleIDs
    }
  }
`;

export const GET_VEHICLE_ACCIDENT_CONTEXT = gql`
  query GetVehicleAccidentContext($vehicleId: ID!, $accidentId: ID!) {
    vehicleAccidentContext(vehicleId: $vehicleId, accidentId: $accidentId) {
      id
      vehicleId
      accidentId
      plate
      model
      color
      category
      insurance
      policyNumber
      isTrailer
      isActive
      ownership
      usage
      numberOccupants
      parentVehicleContextId
      childVehicleContextIDs
      createdAt
    }
  }
`;

// Eliminado: GET_VEHICLES_FOR_ACCIDENT - violaba el patrón de arquitectura
// Usar GET_VEHICLE_CONTEXTS_BY_ACCIDENT y queries separadas para vehículos individuales

export const GET_VEHICLE_HISTORY_CONTEXTS = gql`
  query GetVehicleHistoryContexts($vehicleId: ID!) {
    vehicleHistoryContexts(vehicleId: $vehicleId) {
      id
      vehicleId
      accidentId
      plate
      model
      color
      category
      insurance
      policyNumber
      isTrailer
      isActive
      ownership
      usage
      numberOccupants
      parentVehicleContextId
      childVehicleContextIDs
      createdAt
    }
  }
`;

export const GET_VEHICLE_CONTEXTS_BY_ACCIDENT = gql`
  query GetVehicleContextsByAccident($accidentId: ID!) {
    vehicleContextsByAccident(accidentId: $accidentId) {
      id
      vehicleId
      accidentId
      plate
      model
      color
      category
      insurance
      policyNumber
      isTrailer
      isActive
      ownership
      usage
      numberOccupants
      parentVehicleContextId
      childVehicleContextIDs
      createdAt
    }
  }
`;
